import { Location } from "@angular/common";
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialog } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { TableAction, TableColumn, TablesModule } from "@cotecna/tables";
import { Subscription } from "rxjs";

import { ItemsMainSearch } from "../../model/main-search-result";
import { InspectionListService } from "../../services/inspection-list.service";
import {
  SearchDialogComponent,
  SearchDialogResult,
} from "../search-component/search-dialog.component";
import {
  ITEM_SEARCH_RESULT_TABLE_ACTIONS,
  ITEM_SEARCH_RESULT_TABLE_COLUMNS,
} from "./item-search-result-table-columns";

@Component({
  selector: "im-item-search-result",
  imports: [
    MatCardModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    TablesModule,
    MatIconModule,
  ],
  templateUrl: "./item-search-result.component.html",
  styleUrl: "./item-search-result.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ItemSearchResultComponent {
  public isLoading = true;
  public searchTerm: string;
  public totalTimes: number;
  public totalResults: number;
  public columns: TableColumn[] = ITEM_SEARCH_RESULT_TABLE_COLUMNS;
  public actions: TableAction[] = ITEM_SEARCH_RESULT_TABLE_ACTIONS;

  private queryParamsSubscription: Subscription;
  public inspectionInfo: ItemsMainSearch[] = [];

  constructor(
    public inspectionListService: InspectionListService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private dialog: MatDialog,
    private location: Location,
    private changeDetectorRef: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    this.queryParamsSubscription = this.activatedRoute.queryParams?.subscribe(
      async (params) => {
        this.searchTerm = params.searchTerm;
        this.totalTimes = params.repeatedSearch ? params.repeatedSearch : 0;
        await this.searchItems();
      },
    );
  }

  ngOnDestroy(): void {
    this.queryParamsSubscription?.unsubscribe();
  }

  public async onNewSearchClick(): Promise<void> {
    const searchDialog = this.dialog.open(SearchDialogComponent, {
      data: {
        seletedSearchType: "Search Items",
        searchText: this.searchTerm,
      },
      panelClass: "dialog",
      autoFocus: false,
    });

    const result: SearchDialogResult = await searchDialog
      .afterClosed()
      .toPromise();
    if (result?.action) {
      this.isLoading = true;
      this.inspectionInfo = [];
      if (result.searchType == 0 || result.searchText != this.searchTerm) {
        this.totalTimes = 0;
        this.inspectionListService.search(result.searchText, result.searchType);
      } else {
        this.totalTimes++;
        this.inspectionListService.search(
          result.searchText,
          result.searchType,
          this.totalTimes,
        );
      }
    }
  }

  public onRowClick(event): void {
    const url = this.router
      .createUrlTree([`details/${event.row.inspectionId}/items`], {
        queryParams: { itemId: event.row.itemId },
      })
      .toString();
    window.open(url, "_blank");
  }

  public goBack() {
    this.location.back();
  }

  private async searchItems(): Promise<void> {
    const itemsMainSearch: ItemsMainSearch[] =
      await this.inspectionListService.searchItems(this.searchTerm);
    this.totalResults = itemsMainSearch?.length;
    if (itemsMainSearch?.length) {
      itemsMainSearch.forEach((is) => {
        this.inspectionInfo.push(is);
      });
    }
    this.isLoading = false;
    this.changeDetectorRef.markForCheck();
  }
}
